export class PolicyChangeValidationModel {
    canStart: boolean;
    message: string;
}
